// src/components/DeleteConfirmModal.tsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { User } from "../../PropTypes/UserManagementTypes";
import { useTranslation } from "react-i18next";

type Props = {
  show: boolean;
  onHide: () => void;
  user?: User | null;
  onConfirm: () => Promise<void>;
};

const DeleteConfirmModal: React.FC<Props> = ({ show, onHide, user, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("Confirm Delete")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {user ? (
          <p>{t("Are you sure you want to delete user")} <strong>{user.name}</strong> ({user.email}) ?</p>
        ) : (
          <p>{t("Are you sure?")}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>{t("Cancel")}</Button>
        <Button variant="danger" onClick={onConfirm}>{t("Delete")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;
